"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReduxApp = void 0;
Object.defineProperty(exports, "getStore", {
  enumerable: true,
  get: function get() {
    return _store.getStore;
  }
});
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _components = require("./components");
var _store = require("./store");
var _propTypes = _interopRequireDefault(require("prop-types"));
var ReduxApp = function ReduxApp(_ref) {
  var store = _ref.store,
    siteConfig = _ref.siteConfig;
  return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: store
  }, /*#__PURE__*/_react.default.createElement(_components.App, null));
};
exports.ReduxApp = ReduxApp;
ReduxApp.propTypes = {
  store: _propTypes.default.object.isRequired,
  siteConfig: _propTypes.default.object
};
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-ach/dist/pf-ach.scss');